import { Swiper, Navigation, Autoplay } from "swiper/bundle";
export default class Swiper2 {
    constructor() {
        console.log('%c👍🏼 Swiper Cards', 'color: yellow');
        
        this.swiper2 = document.querySelectorAll(
            '.swiper--cards'
        )
    }
    init() {
        this.swiper2.forEach((elem, i) => {
            new Swiper(elem, {
                slidesPerView: 1.5,
                loop: true,
                spaceBetween: 30,
                speed: 1001,
                // autoplay: {
                //     delay: 10000,
                //     disableOnInteraction: true
                // },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                breakpoints: {
                    540: {
                    slidesPerView: 2.3
                    },
                    998: {
                    slidesPerView: 3.5
                    },
                }
            });   
        })
    }
}